import PropTypes from 'prop-types';
import { fetchAllLanguages } from '@actions/educator';
import QuestionEditor from '@educator/Container/PracticeQuestionEditor/QuestionEditor';

const Add = ({ isServer }) => <QuestionEditor isServer={isServer} />;

Add.getInitialProps = async ({ store, isServer }) => {
  await store.dispatch(fetchAllLanguages());
  return { isServer };
};

Add.pageInfo = {
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default Add;

Add.propTypes = {
  isServer: PropTypes.bool.isRequired
};
